<div class="company-select">

  <ng-select class="custom"
             #select
             [items]="items"
             bindLabel="name"
             bindValue="id"
             [(ngModel)]="selection"
             [multiple]="multiple"
  >
  </ng-select>

</div>
